<script setup>
import InsuranceProgram from '@/components/InsuranceProgram/InsuranceProgram.vue';
defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
</script>
<template>
  <section
    :id="data.id"
    class="section"
    :class="[
      data?.background_color ? `bg-${data?.background_color}` : '',
      data?.spacing?.top ? `section--top-${data.spacing.top}` : '',
      data?.spacing?.bottom ? `section--bottom-${data.spacing.bottom}` : '',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <div class="container">
      <div class="insurance-programs">
        <h2
          v-if="data.title"
          class="mb-0 h2 insurance-programs__title"
          :class="[data?.background_color === 'black' ? 'white' : 'black']"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
          v-html="data.title"
        ></h2>
        <div
          v-if="data?.items && data?.items.length > 0"
          class="insurance-programs__items"
        >
          <div
            v-for="(item, itemIndex) in data?.items"
            :key="itemIndex"
            class="insurance-programs__item"
            data-aos="fade-up"
            :data-aos-delay="itemIndex >= 1 ? 100 + 100 * itemIndex : 100"
          >
            <InsuranceProgram
              :data="item"
              :background-color="data?.background_color"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.insurance-programs {
  $parent: &;
  display: flex;
  flex-direction: column;
  gap: 56px;
  @include media-breakpoint-up(sm) {
    gap: 80px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 80);
  }
  &__items {
    display: flex;
    flex-direction: column;
    gap: 56px;
    @include media-breakpoint-up(sm) {
      gap: 80px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 80);
    }
  }
}
</style>
